import { pxToRem } from '@withjoy/joykit/theme';

/**
 * Header-height constants for the admin header bar.
 *
 * Kept in their own module (no `styled()` components, no `ParticleJoyLogo`) so
 * lightweight consumers — e.g. loading skeletons that are pulled into the
 * synchronous/pre-chunk graph — can read the dimensions without dragging in the
 * full `AdminHeaderBar.styles` dependency graph.
 */

export const ADMIN_HEADER_HEIGHT_MOBILE = 64;
export const ADMIN_HEADER_HEIGHT_DESKTOP = 80;
export const MOBILE_NAV_ROW_HEIGHT = 48;

/**
 * Shared header height constant used by both Root and Spacer components.
 * Ensures spacer height stays in sync with header height.
 */
export const HEADER_HEIGHT = {
  base: pxToRem(ADMIN_HEADER_HEIGHT_MOBILE),
  md: pxToRem(ADMIN_HEADER_HEIGHT_DESKTOP),
} as const;

export const HEADER_HEIGHT_FIXED = pxToRem(80);
